/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ITheme from "@atg/icf-react-components/themes/Theme";
import clsx from "clsx";
import { FC } from "react";
import { createUseStyles } from "react-jss";
import { useMatch } from "react-router-dom";

import CustomLink from "~/components/CustomLink";
import { JSS_MEDIA_TABLET_MAX } from "~/constants";
import NavItemText from "~/features/header/components/NavItemText";
import useOnLanding from "~/hooks/useOnLanding";
import { ComponentBaseProps } from "~/types";

interface StyleProps {
  onLanding: boolean;
}

const useStyles = createUseStyles<string, StyleProps, ITheme>((theme) => ({
  bordered: {
    padding: "3px 12px 4px",
    border: `1px solid ${theme.colors.primary}`,

    [JSS_MEDIA_TABLET_MAX]: {
      padding: (props) => (props.onLanding ? `${theme.spacing.base * 2}px 0` : 0),
    },
  },
}));

interface Props extends ComponentBaseProps {
  to: string;
  hasBorder?: boolean;
  alternativeColor?: boolean;
}

const HeaderNavLink: FC<Props> = ({ to, hasBorder = false, alternativeColor = false, children }) => {
  const match = useMatch(to);

  const onLanding = useOnLanding();

  const classes = useStyles({ onLanding });

  return (
    <CustomLink className={clsx({ [classes.bordered]: hasBorder })} to={to}>
      <NavItemText active={!!match} alternativeColor={alternativeColor}>
        {children}
      </NavItemText>
    </CustomLink>
  );
};

export default HeaderNavLink;
